<div class="detail-contact-screen-container">
    <contact-screen [config]="contactScreenConfig"></contact-screen>
</div>